/**
 * Renders profile form groups for a given role.
 * Group definitions live in profileFormGroups.ts.
 */
import type { Profile } from "@spork/s4p-server-sdk";
import { View } from "react-native";

import type { ProfileFormGroupDefinition } from "../config/profileFormGroups";
import type { ProfileFormFieldHandlers } from "../types/profileFormFieldHandlers";
import { ProfileFormGroup } from "./ProfileFormGroup";

type RoleProfileFormProps = ProfileFormFieldHandlers & {
    person: Profile;
    groups: ProfileFormGroupDefinition[];
};

export function RoleProfileForm({
    person,
    groups,
    ...handlers
}: RoleProfileFormProps) {
    return (
        <View className="gap-6 mb-6">
            {groups.map((group) => (
                <ProfileFormGroup
                    key={group.titleKey}
                    person={person}
                    group={group}
                    {...handlers}
                />
            ))}
        </View>
    );
}
